import styled from 'styled-components';

export const LabelCustom = styled.label`
  text-transform: uppercase;
  color: var(--color-label);
  font-size: calc(var(--font-size) * 0.65);
  font-weight: 900;
  vertical-align: middle;
`;
